export const stringToBooleanInput = value => {
  let booleanValueInput = value.toLowerCase() === 'true' ? true : false;
  return booleanValueInput;
};
